<script lang="ts" setup>
	import imgPlaceholder from '@/assets/images/png/user_placeholder.png'

	export type UserBioContext = Record<
		string,
		{
			value: unknown
			disabled?: boolean
			titleClass?: ClassContext
			descClass?: ClassContext
			wrapperClass?: ClassContext
		}
	>

	defineProps<{
		name?: string
		imgSrc?: string
		subName?: string
		subNameClass?: ClassContext
		imageWrapperClass?: ClassContext
		details: UserBioContext
	}>()
</script>

<template>
	<div>
		<ul class="items- flex w-full flex-col space-y-3">
			<li class="w-full border-b border-gray-200 pb-5 pt-8">
				<div class="flex items-center gap-5 gap-y-2 tracking-wide sm:flex-col sm:justify-center">
					<div
						class="h-[64px] w-[64px] overflow-hidden rounded-full border sm:h-[100px] sm:w-[100px]"
						:class="imageWrapperClass"
					>
						<slot name="user_profile_pics" :src="imgSrc || imgPlaceholder">
							<img
								:preview="false"
								:src="imgSrc || imgPlaceholder"
								:alt="name"
								loading="lazy"
								class="m-auto flex-auto rounded-full text-[10px]"
								:height="100"
								:width="100"
							/>
						</slot>
					</div>
					<slot name="user_profile_bio">
						<div class="pt-2 text-center">
							<slot name="subTitle">
								<p v-if="subName" class="text-xs" :class="subNameClass || 'font-medium'">
									{{ subName }}
								</p>
							</slot>
							<h3 class="text-sm font-medium capitalize text-gray-700">
								{{ name || 'N/A' }}
							</h3>
							<slot name="subName" />
						</div>
					</slot>
				</div>
			</li>

			<li
				v-for="(item, k) in details"
				:key="k"
				class="pt-2 text-sm font-medium leading-[160%] text-gray-600"
				:class="[item.wrapperClass, { hidden: item.disabled }]"
			>
				<span class="text-xs font-normal capitalize text-gray-500" :class="item.titleClass">{{ k }}</span>

				<slot name="value" :record="item" :data-index="String(k)?.toLowerCase().replace(/ /g, '_')">
					<slot :name="String(k)?.toLowerCase().replace(/ /g, '_')" :record="item">
						<h5 :class="item?.descClass">
							{{ item.value || '---' }}
						</h5>
					</slot>
				</slot>
			</li>
			<li class="py-2 text-sm font-medium leading-[160%] text-gray-600">
				<slot name="list-item" :content="details" />
			</li>
		</ul>
	</div>
</template>
